module.exports = __webpack_public_path__ + "img/02.93759c0d.jpg";